<script lang="ts">
    import { Link } from "svelte-navigator";
    import { isAuth } from "../services/auth.service";

    export let to = '';

    let cssClass: string;
    let privateTo: string;

    $: {
        cssClass = $isAuth ? '' : 'disabled';
        privateTo = $isAuth ? to : '';
    }
</script>

<Link to={privateTo} class={cssClass}>
    <slot />
</Link>

<style>
    :global(a.disabled) {
        opacity: .5;
        pointer-events: none;
        text-decoration: none;
        cursor: not-allowed;
    }
</style>
